import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable, Subject } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class SearchProgressService {
  /**
   * Начало основного поиска
   * @private
   */
  private startSubject = new Subject<void>();
  /**
   * Окончание основного поиска
   * @note Имейте ввиду,
   *  после события начала событие окончания может не наступить.
   *  Например, начинаем поиск.Не дожидаясь окончания текущего начинаем новый поиск
   * @private
   */
  private endSubject = new Subject<void>();
  private hideSubject = new Subject<void>();

  /**
   * Текущий прогресс любого поиска, в т.ч. допоиски
   * @private
   */
  private progressSubject = new Subject<number>();

  get start$(): Observable<void> {
    return this.startSubject.asObservable();
  }

  get end$(): Observable<void> {
    return this.endSubject.asObservable();
  }

  get hide$(): Observable<void> {
    return this.hideSubject.asObservable();
  }

  get progress$(): Observable<number> {
    return this.progressSubject.asObservable();
  }

  public start(): void {
    this.startSubject.next();
  }

  public end(): void {
    this.endSubject.next();
  }

  public hide(): void {
    this.hideSubject.next();
  }

  public progress(value: number): void {
    this.progressSubject.next(value);
  }
}
